import { OptionType } from "../../CustomSelect";

export const schoolDistricts: readonly string[] = [
    "Allegheny Valley",
    "Avonworth",
    "Baldwin-Whitehall",
    "Bethel Park",
    "Brentwood Borough",
    "Carlynton",
    "Chartiers Valley",
    "Clairton City",
    "Cornell",
    "Deer Lakes",
    "Duquesne City",
    "East Allegheny",
    "Elizabeth Forward",
    "Fox Chapel Area",
    "Gateway",
    "Hampton Township",
    "Highlands",
    "Keystone Oaks",
    "McKeesport Area",
    "Montour",
    "Moon Area",
    "Mt. Lebanon",
    "North Allegheny",
    "North Hills",
    "Northgate",
    "Penn Hills",
    "Pine-Richland",
    "Pittsburgh Public Schools",
    "Plum Borough",
    "Quaker Valley",
    "Riverview",
    "Shaler Area",
    "South Allegheny",
    "South Fayette Township",
    "South Park",
    "Steel Valley",
    "Sto-Rox",
    "Upper St. Clair",
    "West Allegheny",
    "West Jefferson Hills",
    "West Mifflin Area",
    "Wilkinsburg Borough",
    "Woodland Hills",
    "Armstrong",
    "Apollo-Ridge",
    "Leechburg Area",
    "Freeport Area",
    "Kiski Area",
    "Allegheny-Clarion Valley",
    "Redbank Valley",
    "Karns City Area",
    "Aliquippa",
    "Ambridge Area",
    "Beaver Area",
    "Big Beaver Falls Area",
    "Blackhawk",
    "Central Valley",
    "Freedom Area",
    "Hopewell Area",
    "Midland Borough",
    "New Brighton Area",
    "Riverside Beaver County",
    "Rochester Area",
    "South Side Area",
    "Western Beaver County",
    "Allegheny-Clarion Valley",
    "Butler Area",
    "Freeport Area",
    "Karns City Area",
    "Knoch",
    "Mars Area",
    "Moniteau",
    "Seneca Valley",
    "Slippery Rock Area",
    "Allegheny-Clarion Valley",
    "Clarion Area",
    "Clarion-Limestone Area",
    "Keystone",
    "North Clarion County",
    "Redbank Valley",
    "Union",
    "Crawford Central",
    "Conneaut",
    "Penncrest",
    "Corry Area",
    "Erie City",
    "Fairview",
    "Fort LeBoeuf",
    "General McLane",
    "Girard",
    "Harbor Creek",
    "Iroquois",
    "Millcreek Township",
    "North East",
    "Union City Area",
    "Wattsburg Area",
    "Albert Gallatin Area",
    "Brownsville Area",
    "Connellsville Area",
    "Frazier",
    "Laurel Highlands",
    "Uniontown Area",
    "Carmichaels Area",
    "Central Greene",
    "Jefferson-Morgan",
    "Southeastern Greene",
    "West Greene",
    "Homer-Center",
    "Indiana Area",
    "Marion Center Area",
    "Penns Manor Area",
    "Purchase Line",
    "United",
    "Laurel",
    "Mohawk Area",
    "Neshannock Township",
    "New Castle Area",
    "Shenango Area",
    "Union Area",
    "Wilmington Area",
    "Commodore Perry",
    "Farrell Area",
    "Grove City Area",
    "Hermitage",
    "Jamestown Area",
    "Lakeview",
    "Mercer Area",
    "Reynolds",
    "Sharon City",
    "Sharpsville Area",
    "West Middlesex Area",
    "Wilmington Area",
    "Berlin Brothersvalley",
    "Conemaugh Township Area",
    "Meyersdale Area",
    "North Star",
    "Rockwood Area",
    "Salisbury-Elk Lick",
    "Shade-Central City",
    "Shanksville-Stonycreek",
    "Somerset Area",
    "Turkeyfoot Valley Area",
    "Windber Area",
    "Cranberry Area",
    "Franklin Area",
    "Oil City Area",
    "Valley Grove",
    "Avella Area",
    "Bentworth",
    "Bethlehem-Center",
    "Burgettstown Area",
    "California Area",
    "Canon-McMillan",
    "Charleroi",
    "Chartiers-Houston",
    "Fort Cherry",
    "McGuffey",
    "Peters Township",
    "Ringgold",
    "Trinity Area",
    "Washington",
    "Belle Vernon Area",
    "Burrell",
    "Derry Area",
    "Franklin Regional",
    "Greensburg Salem",
    "Hempfield Area",
    "Jeannette City",
    "Kiski Area",
    "Latrobe (Greater Latrobe)",
    "Ligonier Valley",
    "Monessen City",
    "Mount Pleasant Area",
    "New Kensington–Arnold",
    "Norwin",
    "Penn-Trafford",
    "Southmoreland",
    "Yough",
] as const;

export const schoolDistrictOptionLabels: OptionType[] = Array.from(
    new Set(schoolDistricts)
)
    .sort()
    .map((district) => ({
        label: district,
        value: district,
    }));
